// extracted by mini-css-extract-plugin
module.exports = {"widget-container":"_93444fe79c--widget-container--DyFB0"};